import { Component, OnInit } from '@angular/core';
import { DataApiService } from './../../services/data-api.service';
import { BookInterface } from './../../models/book';
import { NgForm } from '@angular/forms';

import { AuthService } from './../../services/auth.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { UserInterface } from '../../models/user';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {



  constructor(private dataApi: DataApiService, private authService: AuthService) { }
 private books: BookInterface [];
 public isAdmin: any = null;
 public userUid: string = null;

 user: UserInterface ={
   name: '',
   email:'',
   photoUrl:'',
   roles: {

   }
 }

  ngOnInit() {
this.getListBooks();
this.getCurrentUser();
  }

getCurrentUser(){
  this.authService.isAuth().subscribe(
    auth => {
     if(auth){
       this.userUid = auth.uid;
       this.authService.isUserAdmin(this.userUid).subscribe(userRole => {
this.isAdmin = Object.assign({}, userRole.roles
  ).hasOwnProperty('admin');
  //this.isAdmin = true;
       })
     }
    }
  )
}


  getListBooks(){
    this.dataApi.getAllBooks().subscribe( books =>{
   this.books = books;
    });

  }

onDeleteBook(idBook: string){
  console.log('DELETE BOOK',idBook)
  const confirmation = confirm('Tem a certeza que quer apagar?');
  if(confirmation){
    this.dataApi.deleteBook(idBook);
  }
}

onPreUpdateBook(book: BookInterface){

  console.log('BOOK:', book);

   this.dataApi.selectedBook = Object.assign({},book);
}
}
